import { ProductTileLoadingSkeleton } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileLoadingSkeleton";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import React from "react";

const NUM_OF_PRODUCTS = 12;
const NUM_OF_FILTER_PILLS = 2;

export const LoggedInSearchAndLoggedOutDiscoverLoadingSkeleton = () => {
  return (
    <div className="mx-auto flex w-full max-w-[1920px] flex-col px-4 py-0 lg:px-12">
      {/* Filter Pills */}
      <FilterPillsLoadingList />

      {/* Product Tiles */}
      <ProductTilesLoadingSkeletonGrid />
    </div>
  );
};

export const ProductTilesLoadingSkeletonGrid = () => {
  return (
    <div className="flex w-full">
      <div className="grid w-full grid-cols-2 gap-x-4 gap-y-12 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
        {Array.from({ length: NUM_OF_PRODUCTS }).map((_, index) => (
          <ProductTileLoadingSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

export const FilterPillsLoadingList = () => {
  return (
    <div className="flex flex-row items-center justify-start gap-2 overflow-hidden px-0 py-4">
      {Array.from({ length: NUM_OF_FILTER_PILLS }).map((_, index) => (
        <FilterPill key={index} />
      ))}
    </div>
  );
};

export const SearchPageFooterPlaceholder = () => {
  return <div className="h-[900px] w-full"></div>;
};

const FilterPill = () => {
  return <LoadingSkeleton width="100px" height="40px" borderRadius="20px" />;
};
